/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing($routeProvider: RouteProvider): void {
  $routeProvider
    .when('/survey', {
      templateUrl: require('./survey.template.html'),
      title: 'Zufriedenheitsbefragung',
    });
}
